import { ActionButtons, Button, Heading, MobileNavbar, Para, Stack } from 'ui-components';
import GrayBox from './GrayBox';
import { CompletePreBookingFragment } from 'drycut-graphql';
import { formatDateTime } from 'ui-format-utils';
import { Navigation } from 'navigation';
import { DateTime } from 'luxon';

type Props = {
  preBooking: CompletePreBookingFragment;
};

export function PreBookingDetails({ preBooking }: Props): React.ReactElement {
  const bookTime = DateTime.fromISO(preBooking.bookTime);
  const ceilingTime = bookTime.plus({ minutes: 15 });

  return (
    <Stack
      gap={7}
      className="h-full text-center font-aribau gap-9 lg:gap-7"
      id="main-booking-details"
    >
      <MobileNavbar title="Deine Reservierung" />

      <Stack>
        <Heading variant="h2" className="hidden lg:block">
          Deine Reservierung
        </Heading>

        <Para className="mt-2" pretty>
          Wir haben Deine Reservierung erhalten und Dich eingetragen für einen Cut am:
        </Para>
      </Stack>

      <GrayBox className="gap-2">
        <Para size="xl">
          {formatDateTime(preBooking?.bookTime, {
            weekday: 'long',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })}
        </Para>

        <Stack direction="row" gap={1} className="justify-center">
          <Para as="span" size="xl" weight="medium">
            {bookTime.toFormat('HH:mm')}
          </Para>

          <Para as="span">&ndash;</Para>

          <Para as="span" size="xl">
            {ceilingTime.toFormat('HH:mm')}
          </Para>
        </Stack>
      </GrayBox>

      <Stack gap={2}>
        <Para>im</Para>

        <Para size="2xl" weight="bold">
          DRYCUT {preBooking?.store.name}
        </Para>
      </Stack>

      <Stack>
        <Para pretty size="sm">
          Du erhältst vor dem Cut eine separate sms mit den genauen Buchungsinformationen. Wir
          freuen uns auf Dich!
        </Para>
      </Stack>

      <ActionButtons>
        <Button as="a" href={Navigation.HOME_URL} role="link">
          Schliessen
        </Button>
      </ActionButtons>
    </Stack>
  );
}
